import script from "./Orders.vue?vue&type=script&lang=ts&setup=true"
export * from "./Orders.vue?vue&type=script&lang=ts&setup=true"

import "./Orders.vue?vue&type=style&index=0&id=47e6b2ba&lang=scss"

const __exports__ = script;

export default __exports__